import React, { useState } from "react";

import EditEmployment from "./EditEmployment";

const blankEmployment = { companyId: -1, companyName: "", title: "", from: "", to: "" };

function NewEmploymentLine({ onNewEmployment, disabled = false }) {
  const [adding, setAdding] = useState(false);

  const toggleAdding = () => {
    setAdding((prev) => !prev);
  };

  const confirmAdding = (employment) => {
    setAdding(false);
    onNewEmployment(employment);
  };

  return adding ? (
    <EditEmployment
      employment={blankEmployment}
      onConfirm={confirmAdding}
      onCancel={toggleAdding}
      disabled={disabled}
    />
  ) : (
    <tr>
      <td colSpan="999">
        <button onClick={toggleAdding} type="button" className="btn btn-sm btn-outline-primary" disabled={disabled}>
          New Job
        </button>
      </td>
    </tr>
  );
}

export default NewEmploymentLine;
